import { ReactNode } from "react";
import CardComponent from "../../../../component/card/Card.component";
import GridComponent from '../../../../component/grid/GridComponent.component';
import { Title } from "../../../../component/title/Title";
import { ViewStyled, Padding } from "./Card";

interface CardInterface {
    icon: ReactNode;
    title: string;
    children: ReactNode

}

export default function Card({ icon, title, children }: CardInterface) {
    return (
        <CardComponent margin='0px 0px 20px 0px'   >
            <GridComponent>
                <Padding>
                    {icon}
                </Padding>
                <ViewStyled>
                    <Title fontSize={20}>{title}</Title>
                    {children}
                </ViewStyled>
            </GridComponent>
        </CardComponent>
    )
}